import axios from "axios";
import { useMutation } from "react-query";

const nestPath = process.env.REACT_APP_NEST_API_URL as string;

type LoginPayload = {
    id: string;
    password: { password: string };
    osType: string;
    pushToken: string;
    deviceId: string;
};
type LoginResponse = {
    accessToken: string;
    refreshToken: string;
    isExpert: boolean;
};

export const useLoginWithEmail = () => {
    const loginWithEmail = async ({ id, password, osType, pushToken, deviceId }: LoginPayload): Promise<LoginResponse> => {
        const { data } = await axios.post(`${nestPath}/auth/login/app`, { id, password, osType, pushToken, deviceId });
        return data;
    };

    return useMutation<LoginResponse, Error, LoginPayload>(loginWithEmail);
};

